import config from '@/config';
import { requests } from '.';
const PAYMENTLINKS_SERVICE_URL = config?.PAYMENTLINKS_SERVICE_URL;
/**
 * Function to update payment link by payment link id
 * @param paymentLinkId
 * @param params
 * @returns
 */
const updatePaymentLink = (paymentLinkId, params) => requests(PAYMENTLINKS_SERVICE_URL).put(`payment-links/${paymentLinkId}`, params);
/**
 * Function to update payment status link by payment link id
 * @param paymentLinkId
 * @param params
 * @returns
 */
const updatePaymentLinkStatus = (paymentLinkId, params) => requests(PAYMENTLINKS_SERVICE_URL).patch(`payment-links/${paymentLinkId}`, params);
/**
 * Function to create a new payment link
 * @param params
 * @returns
 */
const createNewPaymentLink = params => requests(PAYMENTLINKS_SERVICE_URL).post('payment-links/', params);
/**
 *  Function to get a payment link by id
 * @param paymentLinkId
 * @returns
 */
const getPaymentLinkById = (paymentLinkId) => requests(PAYMENTLINKS_SERVICE_URL).get(`payment-links/preview?paymentLinkId=${paymentLinkId}`);
/**
 *
 * @param params
 * @returns
 */
const listPaymentLinks = (params) => requests(PAYMENTLINKS_SERVICE_URL).get('payment-links/', { params });
const deletePaymentLink = (paymentLinkId, params) => requests(PAYMENTLINKS_SERVICE_URL).delete(`payment-links/${paymentLinkId}`, {
    data: params,
});
const PaymentLinkService = {
    updatePaymentLink,
    updatePaymentLinkStatus,
    createNewPaymentLink,
    getPaymentLinkById,
    listPaymentLinks,
    deletePaymentLink,
};
export default PaymentLinkService;
